/*
 * PM Nachschub-Hinweis.
 *
 * Blendet den Hinweis beim Variantenwechsel ein und aus. Noetig, weil
 * Horizon beim Wechsel standardmaessig nur die Variantenauswahl neu
 * rendert (siehe assets/variant-picker.js, fetchUpdatedSection) - der
 * Block selbst bleibt stehen, wie er beim Seitenaufbau gerendert wurde.
 *
 * Aufbau wie assets/product-inventory.js: am naechsten Section-Element
 * lauschen, nicht am document, damit ein Schnellkauf-Dialog nicht die
 * Produktseite dahinter umschaltet. Bewusst ohne die @theme-Importe -
 * hier wird nur ein Attribut gesetzt, dafuer braucht es weder die
 * Component-Basisklasse noch morph.
 */

class PmRestockHint extends HTMLElement {
  #scope = null;

  connectedCallback() {
    this.#scope = this.closest('.shopify-section, dialog') ?? document;
    this.#scope.addEventListener('variant:update', this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#scope?.removeEventListener('variant:update', this.#onVariantUpdate);
    this.#scope = null;
  }

  #onVariantUpdate = (event) => {
    const detail = event.detail;
    if (!detail) return;

    // Auf einer Seite mit mehreren Produkten (Empfehlungen, Schnellkauf)
    // nur auf das eigene Produkt reagieren.
    const productId = detail.data?.productId;
    if (productId && this.dataset.productId && String(productId) !== this.dataset.productId) return;

    const available = detail.resource?.available;
    if (typeof available !== 'boolean') return;

    this.hidden = available;
  };
}

if (!customElements.get('pm-restock-hint')) {
  customElements.define('pm-restock-hint', PmRestockHint);
}
